import {createBroadcastChannel} from "helpers/BroadcastChannel";
import {useEffect} from "react";

export const useBroadcastState = <T>(channelName: string, onMessage: (data: T) => void) => {
	useEffect(() => {
		const {subscribe} = createBroadcastChannel<T>(channelName);

		const unsubscribe = subscribe((data) => {
			onMessage(data);
		});

		return () => {
			unsubscribe();
		};
	}, [channelName, onMessage]);
};
